import app from './app';

// Services
export authenticationService from './service/authentication';

// Components
export LogoutLink from './components/logout';
export Authenticated from './components/authenticated-container';
export NotAuthenticated from './components/not-authenticated-container';

export default app;



/** WEBPACK FOOTER **
 ** ./src/interactive-solutions/authentication/index.js
 **/